import { useCallback, useRef } from "react";

export const useDebounce = () => {
  const timerId = useRef<any>();

  const debounceFn = useCallback((func, delay) => {
    if (timerId.current) {
      clearTimeout(timerId.current);
    }
    timerId.current = setTimeout(func, delay);
  }, []);

  return debounceFn;
};
